import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Signification from './components/Signification';
import Vision from './components/Vision';
import Valeurs from './components/Valeurs';
import Gouvernance from './components/Gouvernance';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from '../../components/feature/ScrollToTop';
import { useSEO } from '../../utils/seo';

export default function Home() {
  useSEO({
    title: 'OTOROBOTS CANADA INC. — Là où les systèmes intelligents servent l\'humain',
    description: 'OTOROBOTS CANADA INC. conçoit des systèmes technologiques et organisationnels qui permettent aux individus et aux organisations de se développer de façon cohérente, responsable et alignée. Structure canadienne au service de l\'humain.',
    keywords: 'OTOROBOTS, intelligence artificielle, automatisation, technologie humaine, gouvernance, Canada',
    canonical: '/',
    ogTitle: 'OTOROBOTS CANADA INC. — Là où les systèmes intelligents servent l\'humain',
    ogDescription: 'Structure canadienne concevant des systèmes technologiques au service de l\'humain',
    ogType: 'website',
    ogImage: 'https://static.readdy.ai/image/a16a140b1ca96878839a6d35b91aba7d/90e6c0507c04b23ac45764b988f5600d.png',
    schema: {
      '@type': 'Organization',
      name: 'OTOROBOTS CANADA INC.',
      description: 'Structure canadienne concevant des systèmes technologiques et organisationnels au service de l\'humain',
      logo: 'https://static.readdy.ai/image/a16a140b1ca96878839a6d35b91aba7d/90e6c0507c04b23ac45764b988f5600d.png',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'info@otorobots.com',
        contactType: 'customer service',
      },
    },
  });

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <Signification />
      <Vision />
      <Valeurs />
      <Gouvernance />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
}
